import React from "react";
import { displayLabel } from "../../utils/displayLabel";

export default function ReaderPageLayout({
  title,
  description,
  children,
  contentClassName = "",
  sectionClassName = "",
  centeredHeader = false,
}) {
  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className={`space-y-8 ${sectionClassName}`.trim()}>
        {(title || description) && (
          <header className={centeredHeader ? "text-center" : "text-left"}>
            {title && (
              <h1 className="text-2xl sm:text-3xl font-serif text-bookish-purple">
                {typeof title === "string" ? displayLabel(title) : title}
              </h1>
            )}
            {description && (
              <p className="mt-2 text-sm sm:text-base text-gray-700">{description}</p>
            )}
          </header>
        )}
        <section className={contentClassName}>{children}</section>
      </div>
    </div>
  );
}
